import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/login/login-qllLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-0c86c1e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login flex j-c a-c" }
const _hoisted_2 = { class: "login-main flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-main-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "企联联")
], -1))
const _hoisted_4 = { class: "login-main-right flex f-d j-s-e a-c" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "登录", -1))
const _hoisted_6 = { class: "remember-forget flex j-s-b" }
const _hoisted_7 = { class: "remember flex j-s" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "记住密码", -1))

import { useRouter } from "vue-router";
import { onBeforeMount, onMounted, reactive } from "vue";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import { SystemSuppliedEntityInfo } from "@/services/datatype/entity/SystemSuppliedEntityInfo";
import { ElMessage } from "element-plus";
import UserTools from "@/services/session/UserTools";

interface userInfoInt {
  mobile: string;
  password: string;
  remember: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

let userInfo: userInfoInt = reactive({
  mobile: "",
  password: "",
  remember: false,
});

const checkRemember = () => {
  userInfo.remember = !userInfo.remember;
};

const router = useRouter();
const qllLogin = async (): Promise<void> => {
  /*if(!(/^1[3-9][0-9]{9}$/.test(userInfo.mobile))){
    alert('请输入正确的手机号!')
    return
  }*/

  DefaultWebServiceFactory.getInstance()
    .getWebSystemService()
    .login(userInfo.mobile, userInfo.password, userInfo.remember, 0)
    .then((t: SystemSuppliedEntityInfo) => {
      if (t) {
        // console.log(t);
        if (userInfo.remember) {
          localStorage.setItem("mobile", userInfo.mobile);
          localStorage.setItem("password", userInfo.password);
          localStorage.setItem("remember", userInfo.remember.toString());
        } else {
          localStorage.removeItem("mobile");
          localStorage.removeItem("password");
          localStorage.removeItem("remember");
        }
        console.log(UserTools.isLawyer());
        localStorage.setItem("userRoleIndex", "0");
        UserTools.isLawyer()
          ? router.push("/layout/home")
          : router.push("/layout/order");
        console.log();
        ElMessage({
          type: "success",
          message: "登陆成功",
        });
      }
    })
    // 用户名、密码错误
    .catch((err) => {
      ElMessage({
        type: "error",
        message: err.errorMessage,
      });
    });
};
// console.log(UserTools.isLawyer());

onBeforeMount(() => {
  if (localStorage.getItem("mobile")) {
    userInfo = {
      mobile: localStorage.getItem("mobile"),
      password: localStorage.getItem("password"),
      remember: Boolean(localStorage.getItem("remember")),
    };
  }
});
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "mobile",
          type: "text",
          placeholder: "手机号",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userInfo).mobile) = $event))
        }, null, 512), [
          [_vModelText, _unref(userInfo).mobile]
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "password",
          type: "password",
          placeholder: "密码",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(userInfo).password) = $event))
        }, null, 512), [
          [_vModelText, _unref(userInfo).password]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              onClick: checkRemember,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userInfo).remember) = $event))
            }, null, 512), [
              [_vModelCheckbox, _unref(userInfo).remember]
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("button", {
          class: "login-btn",
          onClick: qllLogin
        }, "登录")
      ])
    ])
  ]))
}
}

})